// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph--3Yq8j","alignCenter":"alignCenter--1RKma"};